import { render, staticRenderFns } from "./AxSensorDetailSettingDialog.vue?vue&type=template&id=2f157aaa&scoped=true"
import script from "./AxSensorDetailSettingDialog.vue?vue&type=script&lang=ts"
export * from "./AxSensorDetailSettingDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxSensorDetailSettingDialog.vue?vue&type=style&index=0&id=2f157aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f157aaa",
  null
  
)

export default component.exports